// Zuletzt gedrückte Schaltfläche – Anker für Teilen- und Druck-Popover auf dem iPad (docs/mobile/SPEZIFIKATION.md §3.2).
//
// `document.activeElement` taugt dafür nicht: WebKit fokussiert Schaltflächen beim Antippen nicht, auf dem iPad ist es
// `<body>` – das Popover stand dann unten in der Mitte ohne Bezug zur Schaltfläche. Gemerkt wird darum das Element,
// auf das zuletzt getippt bzw. geklickt wurde. Ein Menüpunkt zählt nicht: Sein Menü schließt gleich wieder; Anker ist
// dann der Auslöser, der das Menü geöffnet hat („Weitere Aktionen“).

const PRESSABLE = 'button, a[href], [role="button"], [role="menuitem"], [role="tab"], summary, input[type="button"], input[type="submit"]'

let last: Element | null = null

function remember(event: Event): void {
  const target = event.target
  if (!(target instanceof Element)) return
  const pressed = target.closest(PRESSABLE)
  if (!pressed) return
  // Menüpunkt: Anker bleibt der Auslöser des Menüs
  if (pressed.closest('[role="menu"], [role="listbox"]')) return
  last = pressed
}

let installed = false

/** Einmal beim Laden des Moduls: merkt sich das gedrückte Element (Zeiger und Tastatur, Fangphase). */
export function watchPressed(doc: Document | undefined = typeof document === 'undefined' ? undefined : document): void {
  if (installed || !doc) return
  installed = true
  doc.addEventListener('pointerdown', remember, true)
  doc.addEventListener('click', remember, true)
}

/** Zuletzt gedrücktes Element, solange es noch im Dokument steht und eine Fläche hat. */
export function lastPressed(): Element | null {
  if (!last || !last.isConnected) return null
  const rect = last.getBoundingClientRect()
  return rect.width === 0 && rect.height === 0 ? null : last
}

/** Nur für Tests. */
export function resetPressed(): void {
  last = null
}

watchPressed()
